import { PDFJS_VIEWER_PATH } from "components/PDFViewer/helper";
import { isEmpty } from "utils/helper/common";

type InitOptions = {
  visibleSaveButton?: boolean;
  visiblePrintButton?: boolean;
};

export default class PDFJs {
  init(
    source: string,
    element: HTMLDivElement,
    highlight?: string[],
    options: InitOptions = {}
  ) {
    const { visibleSaveButton = true, visiblePrintButton = true } = options;
    const iframe = document.createElement("iframe");

    // 完全一致のフレーズが存在する場合は phrase = true で、一番最初の完全一致のフレーズをハイライト
    // https://nikkeilabs.backlog.jp/view/B2B_NVS_FR_2018-3994
    const perfectMatchingStr = highlight?.find(item => /^\".*\"$/.test(item));

    iframe.src = `${PDFJS_VIEWER_PATH}?file=${encodeURIComponent(source)}${
      highlight?.length
        ? `#search=${encodeURIComponent(
            perfectMatchingStr ? perfectMatchingStr : highlight.join(" ")
          )}&phrase=${!isEmpty(perfectMatchingStr)}`
        : ""
    }`;
    iframe.width = "100%";
    iframe.style.border = "none";

    iframe.addEventListener("load", () => {
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) return;

      const hide = (el: HTMLElement | null) => {
        if (el) el.style.display = "none";
      };

      if (!visiblePrintButton && !visibleSaveButton) {
        hide(
          doc.querySelector(
            ".toolbarHorizontalGroup.hiddenMediumView"
          ) as HTMLElement | null
        );
        hide(
          doc.querySelector(
            ".verticalToolbarSeparator.hiddenMediumView"
          ) as HTMLElement | null
        );
        hide(
          doc.querySelector(
            "#secondaryToolbar .visibleMediumView"
          ) as HTMLElement | null
        );
        return;
      }

      if (!visiblePrintButton) {
        hide(doc.getElementById("printButton"));
        hide(doc.getElementById("secondaryPrint"));
      }

      if (!visibleSaveButton) {
        hide(doc.getElementById("downloadButton"));
        hide(doc.getElementById("secondaryDownload"));
      }
    });

    (element as any).appendChild(iframe);
  }
}
